import { gql } from "@apollo/client";

export default gql`
  fragment AssessmentCalibrationQuestion on AssessmentQuestionInterface {
    id
    title
    ... on RangeAssessmentQuestionNode {
      labels
      startValue
      endValue
    }
    ... on TalentIndicatorAssessmentQuestionNode {
      labels
      startValue
      endValue
    }
  }
`;
